<template>
  <v-container id="order-list" fluid tag="section">
    <base-material-card outlined icon="mdi-cash-multiple" class="overflow-visible order-list__wrapper">
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2">Danh Sách đơn hàng</div>
      </template>
      <!-- <v-btn class="mb-2 mr-0 ctv-create-btn" 
        color="primary" 
        v-if="checkAuthorization('order-ctv-create_read')"
        @click="ctvCreate()">
        <span>Tạo mới</span>
        <v-icon style="margin-left: 10px; margin-right: -20px;">mdi-plus</v-icon>
      </v-btn> -->
      <filer-form :filterForm="filterForm" :filterContactStatusList="filterContactStatusList" />
      <v-tabs
        @change="changeTab"
        v-model="tabIndex"
        color="primary"
        style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;"
      >
        <v-tab v-for="(tab, i) in tabs" :key="i">{{ tab }}</v-tab>
      </v-tabs>
      <!-- <v-divider class="ma-4 mb-2"  style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"/> -->
       <order-table :orders="orders" :currentPage="currentPage" />
      <common-no-result v-if="!loading && orders.length === 0" />

      <!-- Paginate -->
      <div class="pb-0 d-flex justify-end px-3 mt-5">
        <div class="text-right mb-1 mt-2">
          {{ showContactsIndex() }}
          <v-btn small class="pagination-btn-left" @click="currentPage--; idPaging = paging.previousId"
            :disabled="currentPage == 1">
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn small class="pagination-btn-right" @click="currentPage++; idPaging = paging.nextId"
            :disabled="!paging.nextId"
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
        <!-- <div style="width: 35px">
          <v-text-field class="pt-0" v-model="pendingPage" min="1" step="1" type="number" @input="applyPendingPage()">
          </v-text-field>
        </div> -->
      </div>

    </base-material-card>
  </v-container>
</template>

<script>
import FilerForm from './components/FilerForm';
import OrderTable from './components/OrderTable';

import RepositoryFactory from '../../repositories/RepositoryFactory';
import TokenService from '../../helpers/token';
const OrderRepository = RepositoryFactory.get('order');
const ContactStatusRepository = RepositoryFactory.get('contact_status');
import * as moment from 'moment';

function getDefaultCreatedAt() {
  return [
    moment().subtract(30, 'days').format('YYYY-MM-DD'),
    moment().format('YYYY-MM-DD')
  ];
}

export default {
  components: {
    FilerForm,
    OrderTable
  },
  data() {
    return {
      filterForm: {
        keyword: '',
        openMenu: false,
        code: '',
        departmentId: '',
        userId: '',
        orderSaleMinistryIds: [],
        userIds: [],
        groupId: '',
        productId: '',
        contactSourceId: '',
        paymentType: '',
        createdAt: getDefaultCreatedAt(),
        receiptCreatedAt: [],
        contactName: '',
        contactMobile: '',
        childName: '',
        childBirthday: '',
        statusIds: [],
        orderGroupType: null,
        typeOrderGroupPrice: 'eq',
        orderGroupPrice: null,
        receiptCode: '',
        paymentPeriod: '',
        
      },
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      orders: [],
      loading: true,
      backward: false,
      paging: {},
      idPaging: null,
      contactStatusList: [],
      tabs: ['Tất cả', 'Đã lên đơn', 'Đã huỷ', 'Đã thành công'],
      tabIndex: 0,
      watchModule: ''
    };
  },
  computed: {
    filterContactStatusList() {
      let contactStatusList = [];
      if (this.tabIndex === 0) {
        return this.contactStatusList;
      } else if (this.tabIndex === 1) {
        contactStatusList = this.contactStatusList.filter(
          status => status.type === 'T3' || status.type === 'C3' || status.type === 'G3'
        );
      } else if (this.tabIndex === 2) {
        contactStatusList = this.contactStatusList.filter(
          status => status.type === 'T2'|| status.type === 'C2' || status.type === 'G2'
        );
      } else if (this.tabIndex === 3) {
        contactStatusList = this.contactStatusList.filter(
          status => status.type === 'T5' || status.type === 'C5' || status.type === 'G5'
        );
      }
      return contactStatusList;
    }
  },
  async created() {
    this.appLoadingData(false)
    const dataUser = TokenService.getUser() || {};
    this.getOrderList();
    this.getContactStatusList();

    const contactId = _.get(this, '$route.params.id', '');
    Bus.$on('order-list-filter', filterForm => {
      this.filterForm = filterForm;
      this.filterForm.openMenu = false;
      this.currentPage = 1;
      this.getOrderList();
    });

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          keyword: '',
          openMenu: false,
          code: '',
          departmentId: '',
          userId: '',
          orderSaleMinistryIds: [],
          userIds: [],
          groupId: '',
          productId: '',
          contactSourceId: '',
          paymentType: '',
          createdAt: getDefaultCreatedAt(),
          receiptCreatedAt: [],
          contactName: '',
          contactMobile: '',
          childName: '',
          childBirthday: '',
          statusIds: [],
          receiptCode: '',
          paymentPeriod: '',
        }
        Bus.$emit('order-list-filter', this.filterForm)
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    Bus.$off('order-list-filter');
    this.watchModule()
  },
  methods: {
    changeTab() {
      if (this.tabIndex === 0) {
        this.filterForm.statusIds = [];
      } else if (this.tabIndex === 1) {
        this.filterForm.statusIds = this.contactStatusList.filter(s => s.name.toLowerCase() == 'bank' 
          || s.name.toLowerCase() == 'cod').map(s => s.id)
      } else if (this.tabIndex === 2) {
        this.filterForm.statusIds = this.contactStatusList.filter(s => s.name.toLowerCase() == 'hủy').map(s => s.id);
      } else if (this.tabIndex === 3) {
        this.filterForm.statusIds = this.contactStatusList.filter(s => s.name.toLowerCase() == 'đã nhận bank' 
          || s.name.toLowerCase() == 'đã nhận cod').map(s => s.id);
      }
      this.currentPage = 1;
      this.getOrderList();
    },
    async getOrderList() {
      const params = {
        limit: this.limit,
        page: this.currentPage,
        keyword: this.filterForm.keyword,
        code: this.filterForm.code,
        departmentId: this.filterForm.departmentId,
        userId: this.filterForm.userId,
        departmentIds: this.filterForm.departmentIds,
        userIds: this.filterForm.userIds,
        groupId: this.filterForm.groupId,
        productId: this.filterForm.productId,
        contactSourceId: this.filterForm.contactSourceId,
        paymentType: this.filterForm.paymentType,
        createdAt: this.filterForm.createdAt.filter(Boolean),
        receiptCreatedAt: this.filterForm.receiptCreatedAt.filter(Boolean),
        orderSaleMinistryIds: this.filterForm.orderSaleMinistryIds.filter(Boolean),
        contactName: this.filterForm.contactName,
        contactMobile: this.filterForm.contactMobile,
        childName: this.filterForm.childName,
        childBirthday: this.filterForm.childBirthday,
        statusIds: this.filterForm.statusIds.filter(Boolean),
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId,
        orderGroupType: this.filterForm.orderGroupType,
        typeOrderGroupPrice: this.filterForm.typeOrderGroupPrice,
        orderGroupPrice: this.filterForm.orderGroupPrice,
        backward: this.backward,
        id: this.idPaging || "",
        isSumPrice: "",
        receiptCode: this.filterForm.receiptCode,
        paymentPeriod: this.filterForm.paymentPeriod,
      };

      if (!this.checkAuthorization('order_view_all')) {
        const dataUser = TokenService.getUser() || {};
        if ( !params.userId && this.isStaff()) {
          params.userId = _.get(dataUser, 'id', '');
        }
        // if (!params.departmentId && this.isLeader()) {
        //   params.departmentId = dataUser.departmentId;
        // }
      }

      if (this.tabIndex > 0 && params.statusIds.length == 0) {
        this.tabIndex = 0;
      }
      
      this.loading = true;
      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const response = await OrderRepository.list(params);
      // loader.hide();
      this.appLoadingData(false)
      this.loading = false;
      if (response.success) {
        this.orders = this.mappingOrderList(_.get(response, 'data.data', []));
        this.paging = {
          nextId: _.get(response, 'data.paging.nextId', null),
          previousId: _.get(response, 'data.paging.previousId', null),
        };
        this.totalItem = _.get(response, 'data.totalItem', 0);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
        this.orders = [];
        this.totalItem = 0;
      }
    },
    mappingOrderList(orders) {
      return orders.map(order => {
        const orderTemp = order;
        let objProductCombo = {};
        let productComboList = [];
        _.get(orderTemp, 'combos', []).forEach(dataCombo => {
          const quantity = _.get(dataCombo, 'OrderProduct.quantity', 0);
          let productComboId = dataCombo.id + '_combo';
          if (!objProductCombo[productComboId]) {
            objProductCombo[productComboId] = {
              name: dataCombo.name,
              quantity: 0
            };
          }
          objProductCombo[productComboId].quantity += quantity;
        });
        _.get(orderTemp, 'products', []).forEach(dataProduct => {
          const quantity = _.get(dataProduct, 'OrderProduct.quantity', 0);
          let productName = dataProduct.name;
          let productId = dataProduct.id;
          if (!objProductCombo[productId]) {
            objProductCombo[productId] = {
              name: productName,
              quantity: 0
            };
            objProductCombo[productId].quantity += quantity;
          }
        });

        for (const productId in objProductCombo) {
          productComboList.push(objProductCombo[productId]);
        }
        orderTemp.rowspan =
          productComboList.length === 0 ? 1 : productComboList.length;
        orderTemp.productComboList = productComboList;
        return orderTemp;
      });
    },
    async getContactStatusList() {
      // const loading = this.$loading.show();
      this.appLoadingData(true)
      const typeArray = ['T2', 'T3', 'T4', 'T5', 'C2', 'C3', 'C4', 'C5', 'G2', 'G3', 'G4', 'G5'];
      const response = await ContactStatusRepository.list({});
      // loading.hide();
      this.appLoadingData(false)
      if (response.success) {
        const contactStatusList = [];
        _.get(response, 'data', []).forEach(contactStatus => {
          if (typeArray.includes(_.get(contactStatus, 'type', '').slice(-2))) {
            _.get(contactStatus, 'data', []).forEach(data => {
              contactStatusList.push({
                type: contactStatus.type,
                id: _.get(data, 'id', 0),
                name: _.get(data, 'name', 0)
              });
            });
          }
        });
        this.contactStatusList = contactStatusList;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    },
    ctvCreate() {
      this.$router.push('/orders/order-create')
    },

    // applyPendingPage: _.debounce(function() {
    //     this.currentPage = parseInt(this.pendingPage) || 1;
    //     this.pendingPage = this.currentPage;
    //     return
    // }, 500),
    showContactsIndex() {
      if(this.orders.length > 0) {
        let maxIndex = parseInt(this.currentPage)*parseInt(this.limit)
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      }else {
        return ('0 - 0')
      }
    },
  },
  watch: {
    currentPage: {
      handler(newVal, oldVal) {
        this.backward = newVal < oldVal;
        this.getOrderList();
      }
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getOrderList();
        } else {
          this.currentPage = 1;
        }
      }
    }
  }
};
</script>
<style scoped>
#order-list {
  padding: 0px 15px;
}
.order-list__wrapper {
  padding-bottom: 0px !important;
  margin-bottom: 10px !important;
}
.ctv-create-btn {
  position: absolute;
  right: 22px;
  top: 10px;
}
</style>
